import { z } from 'zod';

import { formFieldNames, nameMaxLength } from './CreationPopupContent.constants';
import { messages } from './CreationPopupContent.messages';

export const schema = z.object({
    [formFieldNames.fieldType]: z.string().trim().min(1, messages.requiredField),
    [formFieldNames.groupName]: z.string().trim().min(1, messages.requiredField).max(nameMaxLength),
});
